import _ from 'lodash';
import React, { useEffect, useMemo } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useGridApiRef } from '@mui/x-data-grid-pro';
import {
  listOrderLetters,
  unloadOrderLetters,
} from '../../../modules/projectModule/orderLetters';
import OrderBookHistoryList from '../../../components/chancemng/obtainorder/OrderBookHistoryList';

const OrderBookHistoryListContainer = ({ editFunction, setIsActive }) => {
  const dispatch = useDispatch();
  const { chance, orderLetters, loading, error } = useSelector(
    ({ chanceModule, projectModule, loading }) => ({
      chance: chanceModule.chance.chance,
      orderLetters: projectModule.orderLetters.orderLetters,
      loading: loading['chance/LIST_ORDER_LETTERS'],
    }),
  );

  useEffect(() => {
    if (chance) {
      dispatch(listOrderLetters(chance.prjUuid));

      return () => {
        dispatch(unloadOrderLetters());
      };
    }
  }, [dispatch, chance]);

  useEffect(() => {
    if (orderLetters) {
      const filteredActive = orderLetters.filter(
        (order) =>
          order.ordYn.indexOf('Y') !== -1 || order.ordYn.indexOf('S') !== -1,
      );
      const active = _.isEmpty(filteredActive);
      setIsActive(active);
    }
  }, [orderLetters, setIsActive]);

  const apiRef = useGridApiRef();

  const columns = useMemo(
    () => [
      {
        field: 'id',
        headerName: 'ID',
        hide: true,
        type: 'string',
        editable: false,
      },
      {
        field: 'roUuid',
        hide: true,
        type: 'string',
        editable: false,
      },
      {
        field: 'roNo',
        headerName: '품의서번호',
        minWidth: 200,
        flex: 1,
        description: '',
        editable: false,
      },
      {
        field: 'ordYn',
        headerName: '사용여부',
        minWidth: 200,
        flex: 1,
        type: 'string',
        editable: false,
        renderCell: (param) => {
          //Y:사용중 / S: 결제 진행중 / N : 미사용
          let status = '';
          if (param.value === 'Y') {
            status = '사용중';
          } else if (param.value === 'S') {
            status = '결재 진행중';
          } else if (param.value === 'N') {
            status = '미사용';
          }
          return status;
        },
      },

      {
        field: 'crtNm',
        headerName: '등록자',
        minWidth: 80,
        flex: 1,
        type: 'string',
        editable: false,
      },

      {
        field: 'crtDt',
        headerName: '등록일',
        minWidth: 200,
        flex: 1,
        type: 'dateTime',
        editable: false,
      },
      {
        field: 'cngNm',
        headerName: '수정자',
        minWidth: 80,
        flex: 1,
        type: 'string',
        editable: false,
      },

      {
        field: 'cngDt',
        headerName: '수정일',
        minWidth: 200,
        flex: 1,
        type: 'dateTime',
        editable: false,
      },
    ],
    [],
  );

  const handleRowClick = (param, event) => {
    editFunction(param.row);
  };

  return (
    <OrderBookHistoryList
      apiRef={apiRef}
      columns={columns}
      rows={orderLetters}
      error={error}
      loading={loading}
      handleRowClick={handleRowClick}
    />
  );
};

export default OrderBookHistoryListContainer;
